export enum JinroRoomStatus {
  CreatingJinroRoom = "creatingJinroRoom",
  NoGameCreated = "noGameCreated",
  ProcessingNewGame = "processingNewGame",
  Playing = "playing",
  Ended = "ended",
}
